import React from 'react';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { toast } from 'react-toastify';

import api from '../../ApiService';
import { MappingStatus, RevenueCategoryMappingsFilter } from '../../helper';

export default class RevenueCategoryMappings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isDirty: false,
            filter: RevenueCategoryMappingsFilter.NotMapped,
            loadingMappingValidation: true,
            loadingMappingDetails: true,
            mappingsVM: {
                mappings: [],
                iVetRevenueCategories: []
            },
            mappingValidationVM: null
        };

        this.revenueCategoryEditor = this.revenueCategoryEditor.bind(this);
    }

    componentDidMount = async () => {
        this.props.alertRevenueCategoryMappingsComponentOfHospitalChange(this.alertRevenueCategoryMappingsComponentOfHospitalChange);

        this.setState(
            { selectedHospital: this.props.selectedHospital },
            () => {
                this.loadMappings();
                this.loadMappingValidation();
            }
        );
    }

    loadMappings = async () => {
        this.setState({ loadingMappingDetails: true, mappingsVM: { ...this.state.mappingsVM, mappings: [] }});

        let mappingsVM = await api.getRevenueCategoryMappings(this.state.selectedHospital.nameHash, this.state.filter);
        if (mappingsVM) {
            this.setState({
                isDirty: false,
                loadingMappingDetails: false, mappingsVM: mappingsVM
            });
        }
    }

    loadMappingValidation = async () => {
        this.setState({ loadingMappingValidation: true, validationVM: null });

        let mappingValidationVM = await api.getRevenueCategoryMappingValidation(this.state.selectedHospital.nameHash);
        if (mappingValidationVM) {
            this.setState({
                loadingMappingValidation: false, mappingValidationVM: mappingValidationVM
            });
        }
    }

    alertRevenueCategoryMappingsComponentOfHospitalChange = (hospital) => {
        this.setState(
            { selectedHospital: hospital },
            () => {
                this.loadMappings();
                this.loadMappingValidation();
            }
        );
    }

    formatCurrency = (value) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    }

    onClickCancel = async () => {
        await this.loadMappings();
        toast.success("Changes canceled.");
    }

    onClickSave = async () => {
        // Grab only dirty mappings.
        let mappingsToSave = [];
        this.state.mappingsVM.mappings.forEach((value) => {
            if (value.isDirty)
                mappingsToSave.push(value.mapping);
        });

        let success = await api.saveRevenueCategoryMappings(mappingsToSave);
        if (success) {
            // Success. Clear dirty state & reload.
            this.loadMappings();
            this.loadMappingValidation();
            toast.success("Mappings updated.");
        }
    }

    revenueCategoryTemplate = (id) => {
        let name = "(Not Mapped)";

        if (id !== undefined && id) {
            let revenueCategory = this.state.mappingsVM.iVetRevenueCategories.find((val) => { return val.id === id; });
            if (revenueCategory && revenueCategory.name) {
                name = revenueCategory.name;
            }
        }

        return <span>{name}</span>;
    }

    handleFilterChange = async (e) => {
        let filter = e.target.value;
        this.setState({ filter }, this.loadMappings);
    }

    handleMappingSelectChange = (mappingId, field, value) => {
        // Find record using ID.  DataTable-supplied rowIndex may not correlate to index in state. (esp. when sorting)
        let mappings = this.state.mappingsVM.mappings.slice();
        let rowIndex = mappings.findIndex((value) => value.mapping.id === mappingId);

        // Auto-set status.
        let mappingStatus = value ? MappingStatus.Confirmed : MappingStatus.NeedsReview;

        mappings[rowIndex].isDirty = true;
        mappings[rowIndex].mapping = {
            ...mappings[rowIndex].mapping,
            [field]: value,
            mappingStatus
        };

        this.setState({
            isDirty: true,
            mappingsVM: {
                ...this.state.mappingsVM,
                mappings: mappings
            }
        });
    }

    setMappingStatus = (mappingId, newStatus) => {
        // Find record using ID.  DataTable-supplied rowIndex may not correlate to index in state. (esp. when sorting)
        let mappings = this.state.mappingsVM.mappings.slice();
        let rowIndex = mappings.findIndex((value) => value.mapping.id === mappingId);

        mappings[rowIndex] = {
            ...mappings[rowIndex],
            isDirty: true,
            mapping: {
                ...mappings[rowIndex].mapping,
                mappingStatus: newStatus
            }
        };

        this.setState({
            isDirty: true,
            mappingsVM: {
                ...this.state.mappingsVM,
                mappings: mappings
            }
        });
    }

    revenueCategoryEditor = (rowData, rowProps) => {
        let key = `iVetRevenueCategoryId_${rowProps.rowIndex}`;
        let value = 0;
        if (rowData.mapping.iVetRevenueCategoryId) {
            value = rowData.mapping.iVetRevenueCategoryId;
        }

        return (
            <Select disableUnderline
                style={{ width: '100%', maxWidth: '100%' }}
                value={value}
                onChange={(event) => this.handleMappingSelectChange(rowData.mapping.id, 'iVetRevenueCategoryId', event.target.value)}
                inputProps={{ name: key, id: key, key: key }}
            >
                <MenuItem key={0} value={0}>(NOT MAPPED)</MenuItem>
                {this.state.mappingsVM.iVetRevenueCategories.map((revenueCategory, i) => {
                    return <MenuItem key={i + 1} value={revenueCategory.id}>{revenueCategory.name}</MenuItem>;
                })}
            </Select>
        );
    }

    renderMappingValidationTable = () => {
        if (this.state.loadingMappingValidation)
            return <em>Loading...</em>;

        return (
            <Table xs={10}>
                <TableHead>
                    <TableRow className="validation-table-highlight">
                        <TableCell component="th" />
                        <TableCell component="th" style={{ textAlign: 'right', fontWeight: '500', fontSize: 'unset', color: 'black' }}>Current Month</TableCell>
                        <TableCell component="th" style={{ textAlign: 'right', fontWeight: '500', fontSize: 'unset', color: 'black' }}>Last Month</TableCell>
                        <TableCell component="th" style={{ textAlign: 'right', fontWeight: '500', fontSize: 'unset', color: 'black' }}>YTD</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell component="th" scope="row" style={{ fontWeight: '500', fontSize: 'unset' }}>Confirmed</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.mappingValidationVM.confirmedRevenueCurrentMonth)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.mappingValidationVM.confirmedRevenueLastMonth)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.mappingValidationVM.confirmedRevenueYearToDate)}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" scope="row" style={{ fontWeight: '500', fontSize: 'unset' }}>Auto Map (Needs Validation)</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.mappingValidationVM.bestFitRevenueCurrentMonth)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.mappingValidationVM.bestFitRevenueLastMonth)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.mappingValidationVM.bestFitRevenueYearToDate)}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" scope="row" style={{ fontWeight: '500', fontSize: 'unset' }}>Ignored</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.mappingValidationVM.ignoredRevenueCurrentMonth)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.mappingValidationVM.ignoredRevenueLastMonth)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.mappingValidationVM.ignoredRevenueYearToDate)}</TableCell>
                    </TableRow>
                    <TableRow className="validation-table-highlight">
                        <TableCell component="th" scope="row" style={{ fontWeight: '500', fontSize: 'unset' }}>Not Mapped</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.mappingValidationVM.unmappedRevenueCurrentMonth)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.mappingValidationVM.unmappedRevenueLastMonth)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.mappingValidationVM.unmappedRevenueYearToDate)}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        );
    }

    currencyTemplate = (rowData, column) => {
        return <div style={{ textAlign: 'right' }}>{this.formatCurrency(rowData[column.field])}</div>;
    }

    actionTemplate = (rowData) => {
        let mappingId = rowData.mapping.id;
        let mappingStatus = rowData.mapping.mappingStatus;
        if (!mappingStatus)
            mappingStatus = MappingStatus.NeedsReview;

        return (
            <div style={{display: "flex"}}>
                <Checkbox
                    checked={mappingStatus === MappingStatus.Confirmed}
                    onClick={() => this.setMappingStatus(mappingId, mappingStatus !== MappingStatus.Confirmed ? MappingStatus.Confirmed : MappingStatus.NeedsReview)}
                    value={mappingStatus === MappingStatus.Confirmed}
                    color="primary"
                />
                <IconButton aria-label="ignore"
                    color={mappingStatus === MappingStatus.Ignore ? "secondary" : "default"}
                    onClick={() => this.setMappingStatus(mappingId, mappingStatus !== MappingStatus.Ignore ? MappingStatus.Ignore : MappingStatus.NeedsReview)}
                >
                    {mappingStatus === MappingStatus.Ignore && <VisibilityOffIcon />}
                    {mappingStatus !== MappingStatus.Ignore && <VisibilityIcon />}                    
                </IconButton>
            </div>
        );
    }

    renderSaveCancel = (columnSpread) => {
        return (
            <Grid item xs={columnSpread} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                <Button variant='contained' color='default' style={{ marginRight: '15px', minWidth: '80px' }} onClick={this.onClickCancel} disabled={!this.state.isDirty}>Cancel</Button>
                <Button variant='contained' color='primary' onClick={this.onClickSave} style={{ minWidth: '80px' }} disabled={!this.state.isDirty}>Save</Button>
            </Grid>
        );
    }

    renderFilterAndSaveCancel() {
        let filterOptions = [
            RevenueCategoryMappingsFilter.All,
            RevenueCategoryMappingsFilter.Confirmed,
            RevenueCategoryMappingsFilter.Ignored,
            RevenueCategoryMappingsFilter.NeedsReview,
            RevenueCategoryMappingsFilter.NotMapped
        ];

        return (
            <Grid container spacing={24}>
                <Grid item xs={3}>
                    <FormControl fullWidth disabled={this.state.isDirty} >
                        <InputLabel htmlFor="filter" style={{ fontWeight: 'normal' }}>Filter</InputLabel>
                        <Select
                            value={this.state.filter}
                            onChange={this.handleFilterChange}
                            inputProps={{ name: 'filter', id: 'filter' }}
                        >
                            {filterOptions.map((option) => {
                                return <MenuItem key={option} value={option}>{option}</MenuItem>;
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={1} style={{ display: 'flex', alignItems: 'flex-end' }} >
                    {this.state.loadingMappingDetails &&
                        <em>Filtering...</em>}
                </Grid>
                <Grid item xs={4} />
                {this.renderSaveCancel(4)}
            </Grid>
        );
    }

    renderMappingDetails = () => {
        if (this.state.loadingMappingDetails)
            return <em>Loading...</em>;

        return (
            <div>
                <DataTable ref={(el) => this.dt = el} value={this.state.mappingsVM.mappings} style={{ tableLayout: "auto" }} editable>
                    <Column field="mapping.hospitalRevenueCategory"      header="Hospital Code Category" sortable="true" />
                    <Column field="mapping.bestFitiVetRevenueCategoryId" header="Auto Map" body={(rowData) => this.revenueCategoryTemplate(rowData.mapping.bestFitiVetRevenueCategoryId)} sortable="true" />
                    <Column field="mapping.iVetRevenueCategoryId"        header="Revenue Category" body={this.revenueCategoryEditor} sortable="true" />
                    <Column field="revenueCurrentMonth"                  header="Current Month" style={{ width: '12em' }} body={this.currencyTemplate} sortable="true"/>
                    <Column field="revenuePreviousMonth"                 header="Last Month" style={{ width: '12em' }} body={this.currencyTemplate} sortable="true" />
                    <Column field="revenueYearToDate"                    header="YTD" style={{ width: '12em' }} body={this.currencyTemplate} sortable="true" />
                    <Column body={this.actionTemplate} style={{ width: '8em', textAlign: 'left' }} />
                </DataTable>
                <br />
                {this.renderSaveCancel(12)}
            </div>
        );
    }

    render() {
        return (
            <div>
                <br />
                {this.renderMappingValidationTable()}
                <hr />
                {this.renderFilterAndSaveCancel(4)}
                <br />
                {this.renderMappingDetails()}
                <br />
                <br />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Hospitals/RevenueCategoryMappings.js